@let processes = smartProcesses();
@if (!!processes.length) {
  <div class="process-panel-container" [class.expanded]="isExpanded()">
    <mat-expansion-panel
      (opened)="isExpanded.set(true)"
      (closed)="isExpanded.set(false)"
      [expanded]="true"
      class="process-panel"
    >
      <mat-expansion-panel-header>
        <mat-panel-title class="mat-title-small">
          @let incompleteLength = incompleteProcessLength();

          Smart Upload
          @if (incompleteLength) {
            ({{ incompleteProcessLength() }})
          } @else {
            <emperor-icon
              name="bp_check_in_circle"
              class="complete-icon"
              strokeWeight="bold"
            ></emperor-icon>
          }
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="process-list">
        @for (process of processes; track process.upload_id) {
          @let displayName =
            process.filenames.length > 1
              ? `${process.filenames[0]} (+${process.filenames.length - 1})`
              : process.filenames[0];
          <div class="process-item" [class.has-multiple]="processes.length > 1">
            <span
              class="process-name mat-body-medium"
              [class.processing]="
                process.status !== SmartUploadProcessStatus.Completed &&
                process.status !== SmartUploadProcessStatus.Failed
              "
            >
              <span
                class="display-name"
                [class.completed]="
                  process.status === SmartUploadProcessStatus.Completed
                "
                [title]="process.filenames.join(', ')"
              >
                <emperor-icon name="bp_document_text"></emperor-icon>
                {{ displayName }}
              </span>
            </span>
            <div>
              @if (process.status !== SmartUploadProcessStatus.Completed) {
                @let hasFailed =
                  process.status === SmartUploadProcessStatus.Failed;
                <app-process-bar
                  [steps]="[
                    stepLabel(SmartUploadProcessStatus.Extracting),
                    stepLabel(SmartUploadProcessStatus.Enriching),
                    hasFailed
                      ? SmartUploadProcessStatus.Failed
                      : stepLabel(SmartUploadProcessStatus.Completed),
                  ]"
                  [currentStep]="stepLabel(process.status)"
                  [hasFailed]="hasFailed"
                  class="process-bar"
                ></app-process-bar>
              }
              <div class="process-actions">
                @if (
                  process.status === SmartUploadProcessStatus.Completed ||
                  process.status === SmartUploadProcessStatus.Failed
                ) {
                  <emperor-button
                    (click)="removeProcess(process.upload_id)"
                    [uiButtonType]="EmperorUIButtonTypes.Text"
                    [ariaLabel]="'Remove ' + displayName + ' from list'"
                  >
                    Remove
                  </emperor-button>
                }
                @if (
                  process.status === SmartUploadProcessStatus.Completed &&
                  process.application_id
                ) {
                  <emperor-button
                    (click)="navigateToAppForm(process)"
                    [uiButtonType]="EmperorUIButtonTypes.Text"
                    ><span class="view-app-button">
                      <emperor-icon name="bp_logout"></emperor-icon>
                      Open Application
                    </span>
                  </emperor-button>
                } @else if (
                  process.status === SmartUploadProcessStatus.Failed
                ) {
                  <emperor-button
                    (click)="openSmartUploadDialog(process.upload_id)"
                    [uiButtonType]="EmperorUIButtonTypes.Text"
                  >
                    Try Again
                  </emperor-button>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </mat-expansion-panel>
  </div>
}
